import { Button } from '@cian/button-component';
import { RadioGroupField } from '@cian/components';
import * as React from 'react';

import { AsyncActionStatus, TAsyncActionStatus } from '../../../../../store/common';
import { Layout } from '../layout';
import * as styles from './index.css';
import { trackOfferRemoved } from './tracking';

export interface IRemoveProps {
  offerId: number;
  status: TAsyncActionStatus;

  onSubmit(): void;
}

interface IRemoveState {
  value: string;
  isErrorMessageVisible: boolean;
}

const OPTIONS = [
  {
    label: 'Сделка закрыта',
    value: 'Closed',
  },
  {
    label: 'Неликвидный объект',
    value: 'Nonliquid',
  },
  {
    label: 'Удаляю временно, восстановлю позже',
    value: 'Temporary',
  },
  {
    label: 'Другая причина',
    value: 'Other',
  },
];

export class Remove extends React.PureComponent<IRemoveProps, IRemoveState> {
  public state = {
    isErrorMessageVisible: false,
    value: '',
  };

  public render() {
    const { status } = this.props;

    return (
      <Layout
        className={styles['container']}
        isLoading={status === AsyncActionStatus.Loading || status === AsyncActionStatus.Completed}
        title="Почему вы удалили объявление?"
      >
        <div className={styles['options']}>
          <RadioGroupField
            value={this.state.value}
            onValueChange={this.handleChangeValue}
            values={OPTIONS}
          />
        </div>
        <footer>
          <Button onClick={this.submit}>
            Отправить
          </Button>
          {this.state.isErrorMessageVisible &&
            <span className={styles['error']}>
              Укажите причину удаления
            </span>
          }
          {status === AsyncActionStatus.Failed &&
            <span className={styles['error']}>
              Ошибка сервера
            </span>
          }
        </footer>
      </Layout>
    );
  }

  private handleChangeValue = (value: string) => {
    this.setState({
      isErrorMessageVisible: false,
      value,
    });
  }

  private submit = () => {
    if (!this.state.value) {
      this.setState({
        isErrorMessageVisible: true,
      });

      return;
    }

    trackOfferRemoved(this.props.offerId, this.state.value);
    this.props.onSubmit();
  }
}
